import { useState, useEffect } from 'react';
import { getStorageItem, setStorageItem } from '../utils/storage';

export const useSidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = getStorageItem('sidebar-collapsed');
      return stored ? JSON.parse(stored) : false;
    }
    return false;
  });

  const toggle = () => {
    setIsCollapsed(prev => {
      const newValue = !prev;
      setStorageItem('sidebar-collapsed', JSON.stringify(newValue));
      return newValue;
    });
  };

  useEffect(() => {
    setStorageItem('sidebar-collapsed', JSON.stringify(isCollapsed));
  }, [isCollapsed]);

  return { isCollapsed, toggle };
};